import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";
import { PAGE_URLS } from "src/app/core/models/general";

export const TransactionProcessingRoutes: Routes = [
  {
    path: PAGE_URLS.TRANSACTION_PROCESSING,
    loadComponent: () =>
      import("./transaction-processing.component").then(
        (m) => m.TransactionProcessingComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./transaction-processing-form/transaction-processing-form.component").then(
            (m) => m.TransactionProcessingFormComponent,
          ),
      },
    ],
  },
];
